import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { Row, Col, Button, Form, FormGroup, Label, Input } from "reactstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  createDefectNote,
  deleteDefectNote,
  updateDefect,
  updateDefectNote
} from "../../graphql/mutations";
import { connect } from "react-redux";
import { spinnerService } from "@chevtek/react-spinners";
import gql from "graphql-tag";
import { toast } from "react-toastify";
import { listDefectNotes } from "../../graphql/queries.js";
import { Typography } from "@material-ui/core";
import moment from "moment";
import { Storage } from "aws-amplify";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
let noteUpload = null;
class WorkOrder extends React.Component {
  state = {
    start: 0,
    end: 10,
    parts: "",
    _parts: {
      value: "",
      isValid: true,
      err: ""
    },
    notes: "",
    _notes: {
      value: "",
      isValid: true,
      err: ""
    },
    status: "",
    _status: {
      value: "",
      isValid: true,
      err: ""
    },
    notesList: {
      fetched: [],
      temp: []
    },
    noteFile: {},
    editingNote: {},
    repaired: false,
    editing: false,
    deleteNote: {
      id: "",
      dialog: false
    },
    fileView: {
      dialog: false,
      active: ""
    },
    description: "",
    showHistory: false,
    workOrderType: "Create Work Order"
  };
  componentDidMount() {
    this.fetchDefectNotes();
    const { partsUsed, repairNotes, status } = this.props.location.state;
    if (status !== "NEW") {
      this.setState({
        _parts: {
          value: partsUsed,
          isValid: true,
          err: ""
        },
        _notes: {
          value: repairNotes,
          isValid: true,
          err: ""
        },
        _status: {
          value: status,
          isValid: true,
          err: ""
        },
        repaired: status === "REPAIRED" ? true : false,
        workOrderType: "Update Work Order",
        showHistory: ["REPAIRED","REVOKED"].includes(status) ? true : false
      });
    }
  }

  fetchDefectNotes = async () => {
    spinnerService.show("mySpinner");
    let res = await this.props.client.query({
      query: gql(listDefectNotes),
      fetchPolicy: `network-only`
    });
    res = res.data.listDefectNotes.items.filter(
      dn => dn.defectID === this.props.match.params.dId
    );

    this.setState(
      {
        notesList: {
          fetched: res,
          temp: res
        }
      },
      () => spinnerService.hide("mySpinner")
    );
  };

  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  setData = async () => {
    let id = this.props.match.params.dId;
    let description = this.props.location.state.description;
    this.setState({
      description: description
    });
    let {
      parts,
      status,
      notes,
      _parts,
      _status,
      _notes,
      noteFile
    } = this.state;
    if (
      _notes.value === "" ||
      _notes.value === null ||
      _notes.value === undefined
    ) {
      this.submitCheck("_notes", _notes.value);
      // document.getElementById("_notes").focus();
      return false;
    }
    if (
      _status.value === "" ||
      _status.value === null ||
      _status.value === undefined
    ) {
      this.submitCheck("_status", _status.value);
      // document.getElementById("_status").focus();
      return false;
    }
    try {
      (parts = this.state.repaired && _parts.value),
        (notes = _notes.value),
        (status = _status.value);
      this.setState({
        parts: this.state.repaired && _parts.value,
        notes: _notes.value,
        status: _status.value
      });
      spinnerService.show("mySpinner");

      let input = {
        status,
        repairNotes: notes,
        id,
        repairedDateTime: new Date()
      };
      if (this.state.repaired) {
        input.partsUsedInRepair = parts;
      }
      await this.props.client.mutate({
        mutation: gql(updateDefect),
        variables: {
          input
        }
      });
      await this.uploadFiles();
      let defInput = {
        defectID: this.props.match.params.dId,
        addedByUserId: this.props.user.username,
        addedByUserGroup: this.props.user.signInUserSession.idToken.payload[
          "cognito:groups"
        ][0],
        noteText: notes
      };
      if (noteUpload) {
        defInput.noteAttachment = noteUpload;
      }
      await this.props.client.mutate({
        mutation: gql(createDefectNote),
        variables: {
          input: defInput
        }
      });
      noteUpload = null;
      this.setState({
        notes: "",
        noteFile: {},
        _notes: {
          value: "",
          isValid: true,
          err: ""
        }
      });
      if (status === "OPEN") {
        this.fetchDefectNotes();
        toast.success("Note Added");
      } else if (status === "REPAIRED") {
        this.props.history.goBack();
        toast.success("Defect Repaired");
      } else {
        this.props.history.goBack();
        toast.success("No Repair Needed");
      }
      spinnerService.hide("mySpinner");
    } catch (error) {
      toast.error("Adding Note Failed");
      spinnerService.hide("mySpinner");
    }
  };

  updateData = async () => {
    let { editingNote, _notes, notes } = this.state;
    if (
      _notes.value === "" ||
      _notes.value === null ||
      _notes.value === undefined
    ) {
      this.submitCheck("_notes", _notes.value);
      // document.getElementById("_notes").focus();
      return false;
    } else {
      try {
        notes = _notes.value;
        this.setState({
          notes: _notes.value
        });
        spinnerService.show("mySpinner");
        await this.props.client.mutate({
          mutation: gql(updateDefectNote),
          variables: {
            input: {
              id: editingNote.id,
              noteText: notes,
              defectID: this.props.match.params.dId,
              addedByUserId: this.props.user.username,
              addedByUserGroup: this.props.user.signInUserSession.idToken
                .payload["cognito:groups"][0]
            }
          }
        });
        this.setState({
          notes: "",
          _notes: {
            value: "",
            isValid: true,
            err: ""
          },
          editing: false
        });
        this.fetchDefectNotes();
        toast.success("Note updated");
        spinnerService.hide("mySpinner");
      } catch (error) {
        toast.error("Updating Note Failed");
        spinnerService.hide("mySpinner");
      }
    }
  };

  deleteData = async () => {
    const { deleteNote, notesList } = this.state;
    let temp = notesList.fetched;
    temp = temp.filter(t => t.id !== deleteNote.id);
    this.setState({
      notesList: {
        fetched: temp,
        temp
      },
      deleteNote: {
        id: "",
        dialog: false
      }
    });
    try {
      spinnerService.show("mySpinner");
      await this.props.client.mutate({
        mutation: gql(deleteDefectNote),
        variables: {
          input: {
            id: deleteNote.id
          }
        }
      });
      this.fetchDefectNotes();
      toast.success("Note Deleted");
      spinnerService.hide("mySpinner");
    } catch (error) {
      toast.error("Deleting Note Failed");
      spinnerService.hide("mySpinner");
    }
  };

  uploadFiles = async () => {
    const { noteFile } = this.state;
    if (noteFile.name) {
      let key = await Storage.put(
        new Date().getTime() + noteFile.name,
        noteFile
      );
      noteUpload = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
      this.setState({
        noteFile: noteUpload
      });
    }
  };

  editNote = nt => {
    this.setState(
      {
        editingNote: nt,
        notesList: {
          ...this.state.notesList,
          temp: this.state.notesList.fetched
        },
        editing: true
      },
      () => {
        let temp = this.state.notesList.temp;
        document.getElementById("_notes").scroll();
        document.getElementById("_notes").focus();
        this.setState({
          _notes: {
            value: nt.noteText,
            isValid: true,
            err: ""
          },
          notesList: {
            ...this.state.notesList,
            temp: temp.filter(t => t.id !== nt.id)
          }
        });
      }
    );
  };

  deleteNote = id => {
    this.setState({
      deleteNote: {
        id,
        dialog: true
      }
    });
  };

  changeHandler = e => {
    this.setState({ [e.target.id]: e.target.value });
  };
  submitCheck = (id, value) => {
    if (value === "" || value === null || value === undefined) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err:
            id === "_status" ? "Please Select Status" : "This Field is Required"
        }
      });
    }
  };
  runtimeCheck = e => {
    const { id, value } = e.target;
    if (value === "" || value === null || value === undefined) {
      if (id === "_parts" && !this.state.repaired) {
        return;
      }
      this.setState({
        [id]: {
          value,
          isValid: false,
          err:
            id === "_status" ? "Please Select Status" : "This Field is Required"
        }
      });
    }
  };
  _changeHandler = e => {
    const { id, value } = e.target;
    if (id === "_status") {
      this.setState({
        repaired: value === "REPAIRED" ? true : false
      });
    }
    this.setState({
      [id]: {
        value,
        isValid: true,
        err: ""
      }
    });
  };
  viewFileHandler = async key => {
    let url = await Storage.get(key);
    this.setState({
      fileView: {
        dialog: true,
        active: url
      }
    });
  };
  render() {
    const { classes, location, history } = this.props;
    let {
      editing,
      notesList,
      _parts,
      _status,
      _notes,
      deleteNote,
      noteFile,
      fileView,
      showHistory
    } = this.state;
    return (
      <React.Fragment>
        {" "}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div>
            <Dialog
              onClose={() =>
                this.setState({
                  fileView: {
                    ...fileView,
                    dialog: false
                  }
                })
              }
              aria-labelledby="customized-dialog-title"
              open={fileView.dialog}
            >
              <DialogTitle
                id="customized-dialog-title"
                onClose={() =>
                  this.setState({
                    fileView: {
                      ...fileView,
                      dialog: false
                    }
                  })
                }
              />
              <DialogContent>
                <img src={fileView.active} alt="No Preview" />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => window.open(`${fileView.active}`)}
                  color="primary"
                >
                  Download
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <Dialog
            open={deleteNote.dialog}
            keepMounted
            onClose={() =>
              this.setState({
                deleteNote: {
                  id: "",
                  dialog: false
                }
              })
            }
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Delete Note"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Do You Want to Delete This Note ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() =>
                  this.setState({
                    deleteNote: {
                      id: "",
                      dialog: false
                    }
                  })
                }
                color="primary"
                block
              >
                No
              </Button>
              <Button onClick={this.deleteData} color="primary" block>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <GridItem xs={12} sm={8} md={6}>
            <Card>
              <CardHeader style={{ backgroundColor: "black", radius: "15px" }}>
                <h4 className={classes.cardTitleWhite}>Notes</h4>
                <p className={classes.cardCategoryWhite}>
                  {showHistory
                    ? "History"
                    : editing
                    ? "Update Note"
                    : "Add New Note"}
                </p>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col sm={12}>
                      <b>Description: </b>
                      {location.state.description}
                      <hr></hr>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        {/* <Label for="status">
                          <b>Set Status</b>
                        </Label> */}
                        <Input
                          type="select"
                          name="select"
                          id="_status"
                          disabled={showHistory}
                          placeholder="Set Status"
                          value={_status.value}
                          onChange={e => this._changeHandler(e)}
                          onBlur={e => this.runtimeCheck(e)}
                        >
                          <option value={""}>Set Defect Status </option>
                          {/* <option value={"ASSIGNED"}>ASSIGNED</option> */}
                          <option value="OPEN">Open</option>
                          {/* <option value="PENDING">PENDING</option> */}
                          <option value="REPAIRED">Repairs Complete</option>
                          <option value="REVOKED">Repairs Not Needed</option>
                        </Input>
                        {!_status.isValid && (
                          <text
                            style={{
                              color: "red",
                              fontSize: 12,
                              marginLeft: 10
                            }}
                          >
                            {" "}
                            {_status.err}
                          </text>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  {notesList.temp.length > 0 && (
                    <FormGroup>
                      <Label for="">
                        <b>Notes</b>
                      </Label>
                      {notesList.temp
                        .sort(
                          (a, b) => moment(b.createdAt) - moment(a.createdAt)
                        )
                        .map((dn, i) => (
                          <Row key={i}>
                            <Col sm={12}>
                              <div
                                style={{
                                  width: "100%",
                                  minHeight: "60px",
                                  border: "2px groove black",
                                  borderRadius: "5px",
                                  margin: "2px",
                                  display: "flex",
                                  flexDirection: "column"
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "grey"
                                  }}
                                >
                                  <div
                                    style={{ float: "left", padding: "2px" }}
                                  >
                                    <Typography variant="body2">
                                      {dn.addedByUserId}
                                      {"  "}
                                    </Typography>
                                  </div>

                                  <div
                                    style={{ float: "right", padding: "2px" }}
                                  >
                                    <Typography variant="body2">
                                      {moment(new Date(dn.createdAt)).format(
                                        "MM/DD/YYYY, h:mm:ss a"
                                      )}
                                    </Typography>
                                  </div>
                                </div>

                                <div style={{ padding: "3px" }}>
                                  <Typography variant="body1">
                                    {dn.noteText}
                                  </Typography>
                                </div>

                                <div>
                                  {!showHistory &&
                                    dn.addedByUserId ===
                                      this.props.user.username && (
                                      <span>
                                        <span
                                          style={{
                                            padding: "3px",
                                            color: "purple",
                                            cursor: "pointer",
                                            textDecoration: "underline"
                                          }}
                                          onClick={() => this.editNote(dn)}
                                        >
                                          Edit
                                        </span>
                                        <span
                                          style={{
                                            padding: "3px",
                                            color: "purple",
                                            cursor: "pointer",
                                            textDecoration: "underline"
                                          }}
                                          onClick={() => this.deleteNote(dn.id)}
                                        >
                                          Delete
                                        </span>
                                      </span>
                                    )}
                                  {dn.noteAttachment &&
                                    dn.noteAttachment.length > 0 && (
                                      <span
                                        onClick={() =>
                                          this.viewFileHandler(
                                            dn.noteAttachment[0].key
                                          )
                                        }
                                        style={{
                                          padding: "3px",
                                          color: "purple",
                                          cursor: "pointer",
                                          textDecoration: "underline"
                                        }}
                                      >
                                        {"View Attachment"}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ))}
                    </FormGroup>
                  )}

                  {!showHistory && (
                    <Row>
                      <Col sm={12}>
                        <FormGroup>
                          {/* <Label for="_notes">
                          <b>Add New</b>
                        </Label> */}
                          <Input
                            onChange={e => this._changeHandler(e)}
                            onBlur={e => this.runtimeCheck(e)}
                            placeholder="Add New Note"
                            type="textarea"
                            id="_notes"
                            value={_notes.value}
                          />
                          {!_notes.isValid && (
                            <text
                              style={{
                                color: "red",
                                fontSize: 12,
                                marginLeft: 10
                              }}
                            >
                              {" "}
                              {_notes.err}
                            </text>
                          )}
                        </FormGroup>
                        <span style={{ margin: 0, cursor: "pointer" }}>
                          (
                          {!noteFile.name && (
                            <div
                              className="upload-btn-wrapper"
                              style={{
                                marginBottom: -8,
                                cursor: "pointer"
                              }}
                            >
                              <span
                                style={{
                                  cursor: "pointer",
                                  color: "blue",
                                  textDecoration: "underline"
                                }}
                              >
                                Add Attachment
                              </span>
                              <input
                                id="note-pic"
                                type="file"
                                name="noteFile"
                                onChange={e => {
                                  let file = e.target.files[0];
                                  this.setState({
                                    noteFile: file
                                  });
                                }}
                              />
                            </div>
                          )}
                          {noteFile.name && (
                            <span>
                              <span
                                className="badge badge-pill badge-primary"
                                style={{ fontSize: 16 }}
                              >
                                {noteFile.name}
                                <span
                                  style={{ margin: 0, cursor: "pointer" }}
                                  onClick={() =>
                                    this.setState({
                                      noteFile: {}
                                    })
                                  }
                                >
                                  {" "}
                                  x
                                </span>
                              </span>
                            </span>
                          )}
                          )
                        </span>
                      </Col>
                    </Row>
                  )}

                  {/* {this.state.repaired && (
                    <Row>
                      <Col sm={12}>
                        <FormGroup>
                          <Label for="_parts">
                            <b>Parts Used</b>
                          </Label>
                          <Input
                            onChange={e => this._changeHandler(e)}
                            onBlur={e => this.runtimeCheck(e)}
                            type="textarea"
                            id="_parts"
                            value={_parts.value}
                          />
                          {!this.state._parts.isValid && (
                            <text
                              style={{
                                color: "red",
                                fontSize: 12,
                                marginLeft: 10
                              }}
                            >
                              {" "}
                              {this.state._parts.err}
                            </text>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )} */}

                  {!showHistory && (
                    <Row>
                      <Col>
                        <Button
                          color="link"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={() => {
                            if (!editing) {
                              history.goBack();
                            } else {
                              this.setState({
                                _notes: {
                                  value: "",
                                  isValid: true,
                                  err: ""
                                },
                                notesList: {
                                  ...notesList,
                                  temp: notesList.fetched
                                },
                                notes: "",
                                editing: false
                              });
                            }
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          className={classes.blackButton}
                          onClick={() => {
                            if (editing) {
                              this.updateData();
                            } else this.setData();
                          }}
                        >
                          {editing ? "Update" : "Submit"}
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Form>
              </CardBody>
            </Card>
          </GridItem>
        </div>{" "}
        {/* <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Pagination onPageSelect={this.changePage} start={start} data={vehicles} />
          </GridItem>
        </GridContainer> */}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client
  };
};
export default connect(mapStateToProps)(withStyles(styles)(WorkOrder));



// WEBPACK FOOTER //
// ./src/views/Defects/workorder.jsx